module.exports = __webpack_public_path__ + "static/media/HN.ca21772c.svg";